import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import HelpCircle from 'mdi-material-ui/HelpCircle'


const ConfirmDialog = props => {
    const {open, title, content, handleClose, handleConfirm } = props;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description" >

            <DialogTitle id="alert-dialog-title">
                <Box sx={{ display: 'flex', alignContent: 'flex-end', alignItems: 'center' }}>
                    <HelpCircle color="primary" />
                    <div style={{ marginLeft: '8px' }}>{title}</div>
                </Box>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <span dangerouslySetInnerHTML={{ __html: content }} />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>No</Button>
                <Button variant="contained" onClick={handleConfirm} autoFocus>Yes</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDialog